// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_q6-8";
export var editMode = "_q6-3";
export var headerRow = "_q6-a";
export var headerTitle = "_q6-b";
export var product = "_q6-1";
export var productDetails = "_q6-5";
export var productDivider = "_q6-7";
export var productImage = "_q6-2";
export var productInfo = "_q6-4";
export var productTitle = "_q6-6";
export var strikethrough = "_q6-9";
export var upsellProductsCard = "_q6-0";